import { createFileRoute, notFound } from "@tanstack/react-router"

import { VehicleEditRouteComponent } from "@/routes/_authenticated/account/vehicles/edit"
import { cleanEmptyParams } from "@/utilities/etc"
import { meQueryOptions } from "@/utilities/hooks/queries/user"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/vehicles/edit"
)({
  staticData: {
    pageName: "Edit Vehicle",
  },
  validateSearch: (
    search: Record<string, unknown>
  ): {
    plate: string
  } => {
    return cleanEmptyParams({
      plate: (search.plate as string) || "",
    })
  },
  beforeLoad: async ({ context, search }) => {
    const me = await context.queryClient.fetchQuery(meQueryOptions())
    if (
      !search.plate ||
      !me?.inflowUser.savedPlates.some((v) => v.plate === search.plate)
    ) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { plate } = Route.useSearch()
  return <VehicleEditRouteComponent plate={plate} />
}
